import { render } from "./Settlement.vue?vue&type=template&id=123065dc"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Settlement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "123065dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('123065dc', __exports__)) {
    api.reload('123065dc', __exports__)
  }
  
  module.hot.accept("./Settlement.vue?vue&type=template&id=123065dc", () => {
    api.rerender('123065dc', render)
  })

}


export default __exports__